import { useContext as o } from "react";
import { ThemeContext as r } from "styled-components";
const n = () => {
  const e = o(r);
  if (!e)
    throw new Error("ThemeProvider required to access theme");
  return e;
};
export {
  n as useThemeInMode
};
